import { graphql } from '@/gql';

export const tailorBuildingBlock = graphql(`
  mutation tailorBuildingBlock($tailorBuildingBlockInput: TailorBuildingBlockInput!) {
    tailorBuildingBlock(tailorBuildingBlockInput: $tailorBuildingBlockInput) {
      id
    }
  }
`);

export const tailorBuildingBlocks = graphql(`
  mutation tailorBuildingBlocks($tailorBuildingBlocksInput: [TailorBuildingBlockInput!]!) {
    tailorBuildingBlocks(tailorBuildingBlocksInput: $tailorBuildingBlocksInput) {
      id
    }
  }
`);
